<template>
  <a-card
      style="width:100%;height:100%"
      :tab-list="tabListNoTitle"
      :active-tab-key="noTitleKey"
      @tabChange="key => onTabChange(key)"
  >
    <p v-if="noTitleKey === 'gateway-node'">
        <gatewat-node></gatewat-node>
    </p>
    <p v-else-if="noTitleKey === 'web-node'">
        <web-node></web-node>
    </p>
  </a-card>
</template>

<script>

import GatewatNode from "./component/GatewatNode";
import WebNode from "./component/WebNode";


export default {
  name: "index",
  components: {WebNode, GatewatNode},
  data() {
    return {
      noTitleKey: 'gateway-node',
      tabListNoTitle:[
        {
          key: 'gateway-node',
          tab: '网关列表',
        },
        {
          key: 'web-node',
          tab: 'WEB列表',
        },
      ],
    }
  },
  props: {},
  methods: {
    onTabChange(key) {
      this.noTitleKey = key;
    }
  }
}
</script>

<style scoped>

</style>